import React, { MouseEventHandler, useEffect, useState } from "react";
import cn from "classnames";
import styled from "styled-components";

interface IBottomProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sortData: string[];
  initIdx?: number;
  parentSortIdxFunc?: any;
}

const SearchSortItem = (props: IBottomProps) => {
  const [activeSort, setActiveSort] = useState(props.initIdx);

  const handleClick = (idx: number) => {
    setActiveSort(idx);
    props.parentSortIdxFunc(idx);
  };

  return (
    <>
      {props.sortData.map((v, i) => {
        return (
          <>
            <li key={i}>
              <SortItemSet
                className={cn({ selected: i === activeSort })}
                onClick={(e) => {
                  handleClick(i);
                  props.onClick!(e);
                }}
              >
                {v}
              </SortItemSet>
            </li>
          </>
        );
      })}
    </>
  );
};

const SortItemSet = styled.button`
  width: 100%;
  padding: 30px 0;
  border: none;
  background: none;
  color: #7f7f7f;
  font-size: 25px;
  font-family: "Roboto";
  font-weight: 500;
  &.selected {
    color: ${({ theme }) => theme.color.subMain};
  }
`;

export default SearchSortItem;
